import React, { Fragment } from 'react';
// import { ReportHeader } from '../ReportComponents/ReportHeader';
// import { ReportFooter } from '../ReportComponents/ReportFooter';
// import { ReportTitle } from '../ReportComponents/ReportTitle';
import { ReportContentContainer } from '../ReportComponents/ReportContentContainer';
import { Modal, ModalBody, Col } from 'reactstrap';
import { PrintComponent } from 'cd-eft/components/common/PrintPDF';
import { observer } from 'mobx-react';
// import placeholderImage from 'cd-eft/assets/images/BermSlope.png';
import './WDTConstructionReport.scss';

// Test Data
// import * as mockData3 from './__mock_data__/mockResponseData3.json';
// import * as mockProfileData from './__mock_data__/assumedProfileData.json';
import { ByteArrayToImageUrl } from 'cd-eft/utils/ImageDownload';
import { toTitleCase } from 'cd-eft/utils/stringUtilities';
import { PrintReportFooter } from 'cd-eft/components/Projects/PrintConstructionReports/PrintConstructionReports';
import { getAppVersion } from 'cd-eft/utils/sysUtils';
import { WaterwayConstructionReportRespDTO } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { WDTCValues } from './WDTCEnums';
import { parseStationString } from 'cd-eft/utils/stationUtilities';

interface AddedProjectStatus {
  projectStatus: any;
}

type WDTContentType = WaterwayConstructionReportRespDTO & AddedProjectStatus;

export interface IWDTConstuctionReportProps {
  wdtContent: WDTContentType;
  includeCrossSection: boolean;
  includeCheckout: boolean;
  project: any;
}

export const WDTConstructionReport = (props: IWDTConstuctionReportProps) => {
  return (
    <div className="wdt-construction-report-container">
      <ReportContentContainer>
        {/* 1st Page */}
        <NewPage project={props.project} item={props.wdtContent}>
          <h1 tabIndex={0}>Waterway Construction Report</h1>
          <span tabIndex={0}>NRCS - NETS {getAppVersion('minor')}</span>
          <Row>
            <Col className="p-0">
              <EstimatedQuantities {...props.wdtContent} />
            </Col>
            <Col>
              <TypicalParabolicCrossSection
                image={(props.wdtContent as any).xsectionImage}
                type={(props.wdtContent as any).channelType}
              />
            </Col>
          </Row>
          <WaterwayPlanView wdtContent={props.wdtContent} />
        </NewPage>

        {/* 2nd Page  */}
        {props.wdtContent && props.wdtContent.reachInfoList ? (
          <WaterwayTable project={props.project} wdtContent={props.wdtContent} />
        ) : null}

        {/* 3d Page  */}
        {props.wdtContent && props.wdtContent.stationIdXsectionMap ? (
          <ThreeCrossSectionPage project={props.project} wdtContent={props.wdtContent} />
        ) : null}

        {/* 4th Page  */}
        <WaterwayProfileTable wdtContent={props.wdtContent} project={props.project} />
      </ReportContentContainer>
    </div>
  );
};

// ------------------------------------------------------------------------------------------------------------------
const EstimatedQuantities = (props) => {
  // table 1 header row, 7 data rows, 2 columns
  return (
    <>
      <h3>Estimated Quantities</h3>
      <table className="quantity-table w-100">
        <thead>
          <tr>
            <th>Items</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Earthfill</td>
            <td>{`${props.totalFill.toFixed(2)} cu. yd`}</td>
          </tr>
          <tr>
            <td>Excavation</td>
            <td>{`${props.totalCut.toFixed(2)} cu. yd`}</td>
          </tr>
          <tr>
            <td>Waterway Length</td>
            <td>{`${props.waterwayLength.toFixed(2)} ft`}</td>
          </tr>
          <tr>
            <td>Waterway Area</td>
            <td>{`${props.waterwayArea.toFixed(2)} ac`}</td>
          </tr>
          <tr>
            <td>Additional Seeding Area</td>
            <td>{`${props.seedingArea.toFixed(2)} ac`}</td>
          </tr>
          <tr>
            <td>{props.waterWayType.toLowerCase().includes('grass') ? 'Clearing (If applicable)' : 'Liner'}</td>
            <td>{`${props.clearing ? props.clearing.toFixed(2) + ' cu. yd' : ''}`}</td>
          </tr>
          <tr>
            <td>Other</td>
            <td>{`${props.other ? props.other : ''}`}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

const TypicalParabolicCrossSection = ({ image, type }) => {
  // image, same height as above table and on same grid row
  return (
    <>
      <h3>Typical {toTitleCase(type)} Cross Section</h3>
      <img src={ByteArrayToImageUrl(image)} />
    </>
  );
};

interface IWaterwayPlanView {
  wdtContent: WDTContentType;
}
const WaterwayPlanView = observer((props: IWaterwayPlanView) => {
  // images of AOI
  // 2 images - known height
  const { wdtContent } = props;
  return (
    <Row>
      <Col className="plan-view-container">
        <h3>{wdtContent.waterwayName} Plan View</h3>
        {wdtContent.waterwayPlanViewImage && wdtContent.waterwayPlanViewImage.length > 0 ? (
          <img src={ByteArrayToImageUrl(wdtContent.waterwayPlanViewImage as unknown as Int8Array)} />
        ) : null}
      </Col>
      <Col>
        <h3>Location Map</h3>
        {wdtContent.locationMapImage && wdtContent.locationMapImage.length > 0 ? (
          <img src={ByteArrayToImageUrl(wdtContent.locationMapImage as unknown as Int8Array)} />
        ) : null}
      </Col>
    </Row>
  );
});
// ------------------------------------------------------------------------------------------------------------------

// ------------------------------------------------------------------------------------------------------------------
interface WWRTableRow {
  reachId: string;
  startStation: string;
  endStation: string;
  length: number;
  slope: number;
  leftSS: number;
  bottomWidth: number;
  rightSS: number;
  flowTopWidth: number;
  flowDepth: number;
}
interface WWRTableProps {
  // tableData: WWRTableRow[];
  // additionalInfo: string;
  project: any;
  wdtContent: WDTContentType;
}
const WaterwayTable = (props: WWRTableProps) => {
  // Reach table - start on page 2
  // 1 header row, 1 start row - mostly empty, n data rows for R-1 to R-n, 1 reach id column, 9 other data columns
  const { project, wdtContent } = props;
  const channelType = wdtContent.channelType!;
  // const chunkedData = arrayTo2d(data, 25);
  const { firstPage, wholePages } = splitTable(wdtContent.reachInfoList!, 25, 25);

  return (
    <>
      <NewPage project={props.project} item={props.wdtContent}>
        <h3>Table</h3>
        <WaterwayTableComponent
          tableData={firstPage}
          channelType={channelType}
          waterwayType={wdtContent.waterWayType!}
        />

        {(!wholePages && props.wdtContent.additionalInformation) || props.wdtContent.onCallNumber ? (
          <AdditionalInformation text={props.wdtContent.additionalInformation} onCall={props.wdtContent.onCallNumber} spoilDisposal={props.wdtContent.spoilDisposal} />
        ) : null}
      </NewPage>

      {wholePages && wholePages.length > 0
        ? wholePages.map((chunk, i) => (
          <NewPage key={`WaterwayTableComponent-chunk-${i}`} item={wdtContent} project={project}>
            <WaterwayTableComponent
              tableData={chunk}
              channelType={channelType}
              waterwayType={wdtContent.waterWayType!}
            />
            {(i === wholePages.length && props.wdtContent.additionalInformation) || props.wdtContent.onCallNumber ? (
              <AdditionalInformation
                text={props.wdtContent.additionalInformation}
                onCall={props.wdtContent.onCallNumber}
                spoilDisposal={props.wdtContent.spoilDisposal}
              />
            ) : null}
          </NewPage>
        ))
        : null}
    </>
  );
};

const TrapezoidalHeaders = () => {
  return (
    <Fragment>
      <th>Left SS (ft/ft)</th>
      <th>Bottom Width (ft)</th>
      <th>Right SS (ft/ft)</th>
    </Fragment>
  );
};
const TrapezoidalValues = ({ data }) => {
  return (
    <Fragment>
      <td>{data.leftSS.toFixed(1)}</td>
      <td>{data.bottomWidth.toFixed(1)}</td>
      <td>{data.rightSS.toFixed(1)}</td>
    </Fragment>
  );
};
const ParabolicValues = ({ data }) => {
  return (
    <Fragment>
      <td>{data.limitingSlope.toFixed(1)}</td>
      <td>{data.offset1.toFixed(1)}</td>
      <td>{data.offset2.toFixed(1)}</td>
      <td>{data.offset3.toFixed(1)}</td>
    </Fragment>
  );
};
const ParabolicHeaders = () => {
  return (
    <Fragment>
      <th>Limiting Slope (ft/ft)</th>
      <th>Offset 1 (%)</th>
      <th>Offset 2 (%)</th>
      <th>Offset 3 (%)</th>
    </Fragment>
  );
};
const LinerValues = ({ data }) => {
  return (
    <Fragment>
      <td>
        {data.liningMaterial} ({data.thickness.toFixed(2)})
      </td>
      <td>{data.volumeOfLiner.toFixed(2)}</td>
    </Fragment>
  );
};
const LinerHeaders = () => {
  return (
    <Fragment>
      <th>Lining Material (Thickness (in))</th>
      <th>Volume of Liner (cu. yd)</th>
    </Fragment>
  );
};
interface IReachTableProps {
  channelType: string;
  tableData: any;
  waterwayType: string;
}
const WaterwayTableComponent = (props: IReachTableProps) => {
  return (
    <table className="wdt-const-table">
      <thead>
        <tr>
          <th>Reach</th>
          <th>Start (ft)</th>
          <th>End (ft)</th>
          <th>Length (ft)</th>
          <th>Slope (%)</th>
          {props.channelType.toLowerCase().includes('trapezoid') ? <TrapezoidalHeaders /> : <ParabolicHeaders />}
          <th>Flow Depth + FB (ft)</th>
          <th>Flow Top Width (ft)</th>
          {props.waterwayType.toLowerCase().includes('line') ? <LinerHeaders /> : null}
        </tr>
      </thead>
      <tbody>
        {props.tableData.map((row, index) => isStartEndExcluded(row.reachId, row.length) ? null : (
          <tr key={`WaterwayTableComponent-row-${index}`}>
            <td>{row.reachId}</td>
            <td>{row.startStation}</td>
            <td>{row.endStation}</td>
            <td>{row.length.toFixed(1)}</td>
            <td>{(row.slope * 100).toFixed(2)}</td>
            {props.channelType.toLowerCase().includes('trapezoid') ? (
              <TrapezoidalValues data={row} />
            ) : (
              <ParabolicValues data={row} />
            )}
            <td>{row.flowDepth.toFixed(1)}</td>
            <td>{row.flowTopWidth.toFixed(1)}</td>
            {props.waterwayType.toLowerCase().includes('line') ? <LinerValues data={row} /> : null}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
const isStartEndExcluded = (reachId: string, length: number) => {
  if (reachId === 'START' || reachId === 'END') {
    if (length === 0) {
      return true;
    }
  }
  return false;
}
const AdditionalInformation = ({ text, onCall, spoilDisposal }) => {
  // block of text
  // with WaterwayTable on own page
  return (
    <>
      <h3>Additional Information</h3>
      {text ? <p>{text}</p> : null}
      {spoilDisposal ? <p>{spoilDisposal}</p> : null}
      {onCall ? <p>{onCall}</p> : null}
    </>
  );
};
// ------------------------------------------------------------------------------------------------------------------

// ------------------------------------------------------------------------------------------------------------------
interface ITCSProps {
  // imageMap: any;
  project: any;
  wdtContent: WDTContentType;
}
const ThreeCrossSectionPage = (props: ITCSProps) => {
  // optional - starts on own page, n images - known height, 3 per page
  const images = props.wdtContent.stationIdXsectionMap!;
  const chunkSize = 3;
  const keys = Object.keys(images).sort((a, b) => parseStationString(a) - parseStationString(b));
  const chunks = arrayTo2d(keys, chunkSize);

  return (
    <>
      {chunks &&
        chunks.length > 0 &&
        chunks.map((chunk, chunkIndex) => (
          <NewPage key={`ThreeCrossSectionPage-NewPage-${chunkIndex}`} project={props.project} item={props.wdtContent}>
            {chunkIndex === 0 ? <h3>Three Cross Section</h3> : null}
            {chunk.map((key, index) => (
              <div key={`ThreeCrossSectionPage-NewPage-${chunkIndex}-${index}`} className="tcs-container">
                <h4>{key}</h4>
                <img src={ByteArrayToImageUrl(images[key] as unknown as Int8Array)} />
              </div>
            ))}
          </NewPage>
        ))}
    </>
  );
};
// ------------------------------------------------------------------------------------------------------------------

interface ICheckoutSheetProps {
  seedingArea: number;
  totalLength: number;
  cut: number;
  fill: number;
  benchmarkElevation: number;
  waterwayName: string;
  wdtContent: WDTContentType;
  project: any;
}
const CheckoutSheetPage = (props: ICheckoutSheetProps) => {
  // optional - starts on own page
  // form + profile table
  // table breaks to new page (.new-page class) at set number of rows
  return (
    <div className="checkout-container">
      <h2 className="text-primary">Waterway Construction Checkout Sheet</h2>
      <br></br>
      <Row>
        <VerticalInput label="Surveyed By" />
        <VerticalInput date={true} />
        <VerticalInput label="Checked By" />
        <VerticalInput date={true} />
      </Row>
      <Row>
        <VerticalInput label="Certified By" />
        <VerticalInput date={true} />
        <VerticalInput label="NRCS Rep" />
        <VerticalInput date={true} />
      </Row>
      <div className="col acknowledgment">
        I certify the information recorded on this sheet is a true representation of the actual practice installation
        and the practice as installed does (&nbsp;) or does not (&nbsp;) meet NRCS plans and specifications.
      </div>
      <SectionHeading name={'Benchmark Description'} />
      <Row>
        <HorizontalInput label="BS" />
        <HorizontalInput label="HI" />
        <HorizontalInput label="FS" />
        <div className="col-auto">
          <span>BM Elev:{props.benchmarkElevation.toFixed(2)}</span>
        </div>
      </Row>
      <Row>
        <HorizontalInput label="BS" />
        <HorizontalInput label="HI" />
        <HorizontalInput label="FS" />
        <HorizontalInput label="Elev" />
        <HorizontalInput label="Close" />
      </Row>
      <div className="col acknowledgment">
        {/* This section will be from WDT- Benchmark description “Lorem ipsum dolor sit amet, consectetur adipiscing elit” */}
        {props.wdtContent.benchmarkDescription ? props.wdtContent.benchmarkDescription : null}
      </div>
      <SectionHeading name={'Earthwork'} />
      <Row>
        <ValueDisplay label={'Total Fill (cy)'} value={props.wdtContent.totalFill!.toFixed(2)} />
        <ValueDisplay label={'Total Cut (cy)'} value={props.cut.toFixed(2)} />
        <ValueDisplay label={'Total Length (ft)'} value={props.totalLength.toFixed(2)} />
        <ValueDisplay label={'Seeding Area (ac)'} value={props.seedingArea.toFixed(2)} />
      </Row>
    </div>
  );
};

const NewPage = ({ project, item, children }) => {
  item.name = item.waterwayName;
  item.type = item.waterWayType;
  return (
    <div className="new-page container-outer-border">
      {children}
      <PrintReportFooter item={item} project={project} />
    </div>
  );
};
interface RowProps {
  children: any;
  extraClass?: string;
}
// To avoid repeating <div className="row"> and decrease to just <Row> using reactstrap row,col
const Row = (props: RowProps) => {
  return <div className={`row${props.extraClass ? ` ${props.extraClass}` : ''}`}>{props.children}</div>;
};

const SectionHeading = ({ name }) => {
  return (
    <Row>
      <Col>
        <h3 className="sub-section-heading">{name}</h3>
      </Col>
    </Row>
  );
};
interface IInputProps {
  label?: string;
  value?: string;
  date?: boolean;
}
const VerticalInput = (props: IInputProps) => {
  return (
    <div className={`col-auto checkout-vert-input${props.date ? ' checkout-vert-input-date' : ''}`}>
      <label className="row input-label">{props.date ? 'Date' : props.label}:</label>
      <span className={'row ' + props.date ? 'checkout-date-input' : 'checkout-long-input'}></span>
    </div>
  );
};
const HorizontalInput = (props: IInputProps) => {
  return (
    <div className={`col-auto checkout-horiz-input`}>
      <label className="horizontal-label">{props.date ? 'Date' : props.label}:</label>
      <span className="horizontal-value"></span>
    </div>
  );
};
const ValueDisplay = ({ label, value }) => {
  return (
    <div className="col-3">
      <label className="value-display-label">{label}:&nbsp;&nbsp;&nbsp;</label>
      <span className="value-display-value">{value}</span>
    </div>
  );
};

export function splitTable(data: any[], first, second) {
  let firstPage: any[] | undefined | null = [];
  let wholePages: any[] | undefined | null = [];
  if (data && data.length > first) {
    firstPage = data.slice(0, first);
    wholePages = arrayTo2d(data.slice(first), second);
  } else {
    firstPage = data;
  }
  return { firstPage, wholePages };
}
interface WWPTableProps {
  // waterwayName: string;
  // tableData: any[];
  project: any;
  wdtContent: WDTContentType;
}
const WaterwayProfileTable = ({ wdtContent, project }: WWPTableProps) => {
  const { firstPage, wholePages } = splitTable(wdtContent.waterWayProfileList!, 10, 25);

  return (
    <div>
      <NewPage item={wdtContent} project={project}>
        <CheckoutSheetPage
          cut={(wdtContent as any).totalCut}
          fill={(wdtContent as any).totalFill}
          benchmarkElevation={(wdtContent as any).benchmarkElevation}
          totalLength={(wdtContent as any).waterwayLength}
          seedingArea={(wdtContent as any).seedingArea}
          waterwayName={(wdtContent as any).waterwayName}
          project={project}
          wdtContent={wdtContent}
        />
        {wdtContent.waterWayProfileList ? (
          <>
            <h3>{`${wdtContent.waterwayName} Profile`}</h3>
            {firstPage && firstPage.length > 0 && <WWProfileTableComponent tableData={firstPage} channelType={wdtContent.channelType!} waterwayType={wdtContent.waterWayType!} />}
          </>
        ) : null}
      </NewPage>

      {wholePages && wholePages.length > 0
        ? wholePages.map((chunk, i) => (
          <NewPage key={`WaterwayProfileTable-chunk-${i}`} item={wdtContent} project={project}>
            <WWProfileTableComponent tableData={chunk} channelType={wdtContent.channelType!} waterwayType={wdtContent.waterWayType!} />
          </NewPage>
        ))
        : null}
    </div>
  );
};

const AdditionalLinedHeaders = () => {
  return (
    <Fragment>
      <th>Subgrade (ft)</th>
      <th>Thickness (in)</th>
    </Fragment>
  )
}
const AdditionalLinedValues = ({ subgrade, thickness }) => {
  return (
    <Fragment>
      <td>{subgrade}</td>
      <td>{thickness}</td>
    </Fragment>
  )
}
const ParabolicHeadersProfile = ({ waterwayType }) => {
  return (
    <Fragment>
      <th>Offset 50% Elevation (ft)</th>
      {waterwayType === WDTCValues.linedString ? <AdditionalLinedHeaders /> : null}
    </Fragment>
  )
}
const ParabolicValuesProfile = ({ row, waterwayType }) => {
  return (
    <Fragment>
      <td>{row.offset50Elevation ? row.offset50Elevation.toFixed(2) : ''}</td>
      {waterwayType === WDTCValues.linedString ? <AdditionalLinedValues subgrade={row.subgrade ? row.subgrade.toFixed(2) : ''} thickness={row.thickness ? row.thickness.toFixed(2) : ''} /> : null}
    </Fragment>
  )
}
interface ProfileTableProps {
  tableData: any;
  channelType: string;
  waterwayType: string;
}
const WWProfileTableComponent = (props: ProfileTableProps) => {
  const { tableData, channelType, waterwayType } = props;
  return (
    <table className="wdt-const-table">
      <thead>
        <tr>
          <th>Station</th>
          <th>Height of Instru&shy;ment</th>
          <th>Cut/Fill @ Center&shy;line</th>
          <th>Chan&shy;nel Elev&shy;ation @ Center&shy;line</th>
          {channelType === WDTCValues.trapezoid ? <th>Design Bottom Width</th> : <ParabolicHeadersProfile waterwayType={waterwayType} />}
          <th>%Slope</th>
          <th>Design Depth @ Center&shy;line</th>
          <th>Design Top Width</th>
          <th>Grade Chan&shy;nel Rod</th>
          <th>Actual Chan&shy;nel Rod/ Elev&shy;ation</th>
          <th>Channel Error (+/-)</th>
        </tr>
      </thead>
      <tbody>
        {tableData &&
          tableData.length > 0 &&
          tableData.map((row, index) => (
            <tr key={`WWProfileTable-row-${index}`}>
              <td>{row.stationId}</td>
              <td>{row.hi}</td>
              <td>{row.cutFill.toFixed(2)}</td>
              <td>{row.channelElevation.toFixed(2)}</td>
              {channelType === WDTCValues.trapezoid ? <td>{row.designBottomWidth.toFixed(2)}</td> : <ParabolicValuesProfile row={row} waterwayType={waterwayType} />}
              <td>{(row.grade * 100).toFixed(2)}</td>
              <td>{row.designDepth.toFixed(2)}</td>
              <td>{row.designTopWidth.toFixed(2)}</td>
              <td>{row.gradeChanRod}</td>
              <td>{row.actChanRod}</td>
              <td>{row.chanError}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export interface IFormulaPrintModalProps {
  content: any;
  title: string;
  vm: any;
}

export const TestFormulaPrint = observer((props: IFormulaPrintModalProps) => {
  return (
    <Modal className="project-owner-modal" isOpen={props.vm.saveButtonPopup}>
      <ModalBody>
        <PrintComponent
          componentToPrint={WDTConstructionReport}
          printButtonText={'Report'}
          functionProp={props.vm}
          printButtonClasses={'usa-button usa-button--outline'}
          //componentProps is used to pass the calculation results to the pdf
          componentProps={{ content: props.content, title: props.title }}
        />
      </ModalBody>
    </Modal>
  );
});

/**
 * Accepts a one dimensional array and returns a 2d array with sub arrays of a given size
 * @param array One dimensional array
 * @param chunkSize maximum length of the sub arrays
 * @returns the contents of the array split into separate sub-arrays
 */
export function arrayTo2d(array: any[], chunkSize: number) {
  if (array && array.length > 0) {
    const chunks: any[] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }
}

/** You can include this code in TrapezoidalChannel.tsx, replacing the FormulaPrintModalContainer component.
 *  
  import { TestFormulaPrint } from 'cd-eft/components/Reports/WDTConstructionReport/WDTConstructionReport';
  
  <TestFormulaPrint 
    vm={vm}
    // inputs={vm.exportedInputs}
    // results={vm.exportedResults}
    // images={[vm.image]}
    content={{}}
    title='Waterway Design Construction Report'
  />
 * 
 */
